export const PUBLISHING_IDENTITY_KEY = 'amposter:publishing-identity:v1';

export const readPublishingIdentity = () => {
  try { return JSON.parse(localStorage.getItem(PUBLISHING_IDENTITY_KEY) || 'null'); }
  catch (_) { return null; }
};

export const getActivePublishingTeamId = () => {
  const selected = readPublishingIdentity();
  return selected?.type === 'team' ? selected.teamId : null;
};
